import React, {
  useContext,
  useEffect,
  useState,
  useCallback,
  useRef,
} from "react";
import { useNavigate } from "react-router-dom";
import { AdsData, MarketPlaceCategoryList } from "../Service/SubCategory";
import { FaSearch } from "react-icons/fa";
import MarketplaceCart from "../../../../../components/Dashboard/MarketplaceCart";
import AlertContext from "../../../../../Context/Alert/AlertContext";
import { BaseURL } from "../../../../../Files/BaseURL";
import axios from "axios";
import ThemeContext from "../../../../../Context/theme/ThemeContext";
import { debounce } from "lodash";

const formatPrice = (price) => {
  if (!price) return "$0.00";

  let formattedPrice;
  if (price >= 1000) {
    formattedPrice = `$${(price / 1000).toFixed(2)}K`;
  } else {
    formattedPrice = `$${price.toFixed(2)}`;
  }
  return formattedPrice;
};

const MarketPlaceList = () => {
  const { theme } = useContext(ThemeContext);
  const navigate = useNavigate();
  const [SeletedCategory, setSeletedCategory] = useState();
  const [Categories, setCategories] = useState([]);
  const [Products, setProducts] = useState([]);
  const [distance, setDistance] = useState("");
  const [distanceError, setDistanceError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [tableLoading, setTableLoading] = useState(false);

  const alertContext = useContext(AlertContext);
  const { showAlert } = alertContext;

  // Create observer ref for infinite scroll
  const observer = useRef();
  const lastProductElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPage((prevPage) => prevPage + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  const fetchCategories = async () => {
    try {
      setIsLoading(true);
       const response = await axios.get(
        `${BaseURL}/api/product/productcategory`
      );
      setCategories(response.data);
      setSeletedCategory(response.data[0]?._id);
    } catch (error) {
      showAlert("Error fetching categories", "danger");
    } finally {
      setIsLoading(false);
    }
  };

  const fetchProducts = useCallback(async () => {
    try {
      if (page === 1) {
        setTableLoading(true);
      } else {
        setLoading(true);
      }

      const authToken = localStorage.getItem("p@token");
      const response = await axios.get(
        `${BaseURL}/api/marektplace/products/fetchproducts/${SeletedCategory}`,
        {
          headers: {
            "auth-token": authToken,
          },
          params: {
            page,
            limit: itemsPerPage,
            search: searchTerm,
            distance: distance || undefined,
          },
        }
      );

      if (response.data.success) {
        setProducts(response.data.data);
        setTotalPages(response.data.pagination.totalPages);
        setTotalItems(response.data.pagination.totalItems);
        setHasMore(response.data.pagination.hasMore);
      } else {
      }
    } catch (error) {
    } finally {
      setTableLoading(false);
      setLoading(false);
    }
  }, [page, itemsPerPage, searchTerm, distance, SeletedCategory]);

  // Reset page and fetch when filters change
  useEffect(() => {
    if (SeletedCategory) {
      setPage(1);
      fetchProducts();
    }
  }, [SeletedCategory, searchTerm, itemsPerPage, distance, fetchProducts]);

  // Fetch when page changes
  useEffect(() => {
    if (page > 1) {
      fetchProducts();
    }
  }, [page, fetchProducts]);

  useEffect(() => {
    fetchCategories();
  }, []);

  const validateDistance = (value) => {
    if (value === "") {
      setDistanceError("");
      return true;
    }

    const numValue = Number(value);
    if (numValue <= 0) {
      setDistanceError("Distance must be greater than 0");
      return false;
    }
    setDistanceError("");
    return true;
  };

  const handleDistanceChange = (e) => {
    const value = e.target.value;
    setDistance(value);
    validateDistance(value);
  };

  return (
    <div className="w-[95%] m-auto py-6">
      <div className="flex flex-col gap-4 lg:flex-row justify-between font-pop lg:items-center">
        <div className="flex gap-2 md:gap-6 items-center">
          <h3
            className={` text-lg md:text-2xl font-medium ${
              theme == "dark" && "text-white"
            }`}
          >
            Marketplace
          </h3>
        </div>
        <div className="flex flex-col lg:flex-row lg:items-center gap-2">
          <div className="flex flex-row flex-wrap gap-4 items-center">
            <div className=" flex font-pop flex-row gap-2 items-center rounded-2xl px-1 md:px-3">
              <p
                className={`text-lightGrey ${theme == "dark" && "text-white"}`}
              >
                Distance
              </p>
              <div className="relative">
                <input
                  type="number"
                  value={distance}
                  onChange={handleDistanceChange}
                  min={1}
                  placeholder="Enter Distance in KM"
                  className={`border-none outline-none 
                    focus:outline-none focus:border-none focus:outline-transparent
                    active:border-none active:outline-none text-sm md:text-lg font-normal
                    ${theme == "dark" ? "bg-black text-white" : "bg-gray-300"}
                    ${distanceError ? "border-red-500" : ""}
                  `}
                />
                {distanceError && (
                  <p className="absolute text-red-500 text-xs mt-1">
                    {distanceError}
                  </p>
                )}
              </div>
            </div>
          </div>
          <div
            className={`flex gap-3 items-center  rounded-full py-1 px-4 ${
              theme == "dark" ? "bg-black text-white" : "bg-gray-300"
            } `}
          >
            <FaSearch
              className={` text-gray-400 text-lg md:text-2xl ${
                theme == "dark" && "text-white"
              }`}
            />
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className={`
                          text-sm md:text-lg border-none outline-none focus:outline-none focus:border-none 
                          active:outline-none ${
                            theme == "dark"
                              ? "bg-black text-white"
                              : "bg-gray-300 "
                          } 
                      `}
            />
          </div>
          <div
            className={`bg-primarygreen text-center w-fit border-2 border-primarygreen 
                        rounded-full font-pop text-white py-2 px-5 cursor-pointer
                        ${theme === "dark" && "hover:text-white"}
                      `}
            onClick={() => {
              navigate("/user-dashboard/adds/createadd");
            }}
          >
            Create Ad
          </div>
        </div>
      </div>
      <div className="py-4 flex flex-wrap items-center gap-2">
        {Categories.map((item, index) => (
          <div
            className={`
              cursor-pointer rounded-2xl py-1 px-2 border-2 font-pop 
              ${theme == "dark" ? "bg-black text-white" : "bg-white "} 
              ${
                item._id == SeletedCategory &&
                "border-primarygreen bg-primarygreen/20 "
              }
            `}
            key={index}
            onClick={() => {
              setSeletedCategory(item._id);
            }}
          >
            {item.name}
          </div>
        ))}
      </div>
      <div className="py-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-6">
        {!loading &&
          !tableLoading &&
          Products.map((item) => (
            <MarketplaceCart
              key={item._id}
              item={{
                ...item,
                formattedPrice: formatPrice(item.Price),
              }}
            />
          ))}
      </div>

      {(loading || tableLoading) && (
        <div className="flex justify-center py-4">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primarygreen"></div>
        </div>
      )}

      {!hasMore && !loading && Products.length > 0 && (
        <div className="text-center py-4 text-gray-500">
          No more items to load
        </div>
      )}

      {!loading && Products.length === 0 && (
        <div className="text-center py-4 font-pop text-lg font-medium">
          No products found
        </div>
      )}
    </div>
  );
};

export default MarketPlaceList;
